export default __webpack_public_path__ + "static/media/magazines.9d0766dd.svg";